import React, { Component } from "react";
import axios from "axios";

export class Step2Domain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      internshipDomain: props.formData.internshipDomain || "",
      domains: [],
      loading: true,
      error: "",
    };
  }

  componentDidMount() {
    this.getDomains();
  }

  getDomains = () => {
    axios
      .post("https://idealtechnoride.in/api/domain")
      .then((res) => {
        this.setState({
          domains: res.data,
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          loading: false,
          error: "Unable to load internship domains.",
        });
      });
  };

 handleChange = (e) => {
  const selectedDomain = this.state.domains.find(
    (item) => item.domain_id === e.target.value
  );

  this.setState({
        internshipDomain: selectedDomain.domain_id,
        internshipDomainName: selectedDomain.domain_name,
        error: "",
      });
    };

  handleNext = () => {
    if (!this.state.internshipDomain) {
      this.setState({
        error: "Please select Internship Domain.",
      });
      return;
    }

    this.props.updateFormData({
      internshipDomain: this.state.internshipDomain,         // ID
      internshipDomainName: this.state.internshipDomainName, // Name
    });

    this.props.nextStep();
  };

  render() {
    const { domains, loading, internshipDomain, error } = this.state;

    return (
      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 2 : Select Internship Domain
            </h3>
          </div>

          <div className="card-body">

            <p className="text-muted mb-4">
              Select the internship domain you are interested in.
            </p>

            {loading ? (
              <div className="text-center py-5">
                <h5>Loading Domains...</h5>
              </div>
            ) : (
              <div className="row">

                {domains.map((item) => (

                  <div
                    className="col-md-6 mb-3"
                    key={item.domain_id}
                  >

                    <div
                      className={`card h-100 ${
                        String(internshipDomain) ===
                        String(item.domain_id)
                          ? "border-success border-3"
                          : ""
                      }`}
                    >

                      <div className="card-body">

                        <div className="form-check">

                          <input
                            className="form-check-input"
                            type="radio"
                            name="internshipDomain"
                            id={`domain${item.domain_id}`}
                            value={item.domain_id}
                            checked={
                              String(internshipDomain) ===
                              String(item.domain_id)
                            }
                            onChange={this.handleChange}
                          />

                          <label
                            className="form-check-label fw-bold fs-5"
                            htmlFor={`domain${item.domain_id}`}
                          >
                            {item.domain_name}
                          </label>

                        </div>

                        <small className="text-muted d-block mt-2">
                          {item.technology_name}
                        </small>

                      </div>

                    </div>

                  </div>

                ))}

              </div>
            )}

            {error && (
              <div className="alert alert-danger mt-3">
                {error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-success"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default Step2Domain;